import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { getRaceStartTypeEnum, RaceAdminSummaryDto, RaceStartTypeEnum, RaceStatusEnum, ResultsStatusEnum } from '@aoe/client';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, Observable, Subject, takeUntil, timer } from 'rxjs';
import { toDatetimeLocal } from 'src/app/core/helpers/Date.helpers';
import { FormHelper } from 'src/app/core/helpers/form.helper';
import { raceAdminActions } from 'src/app/core/store/admin/race-admin/raceAdmin.action';

@Component({
  selector: 'aoe-start-race',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, FormsModule, MatSelectModule, MatSlideToggleModule, MatFormFieldModule, MatInputModule],
  templateUrl: './start-race.component.html',
  styleUrl: './start-race.component.scss'
})
export class StartRaceComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  raceTimingForm!: FormGroup;
  startTypeLabel: any;
  resultStatusLabel: any;
  resutsStatus: any;
  startType: any;
  isInputValid: (control: FormControl | AbstractControl) => boolean;
  displayError: (control: FormControl | AbstractControl) => boolean;
  currentTime!: string;

  now$: Observable<Date> = timer(0, 1000).pipe(
    map(() => new Date())
  );

  differedTime = new FormControl(false);
  raceName!: string | null;

  constructor(
    formHelper: FormHelper,
    @Inject(MAT_DIALOG_DATA) private readonly data: { race: RaceAdminSummaryDto, eventId: string },
    private readonly fb: FormBuilder,
    private readonly store: Store,
    private actions$: Actions,
    private readonly matDialogRef: MatDialogRef<StartRaceComponent>
  ) {
    this.isInputValid = formHelper.isInputValid;
    this.displayError = formHelper.displayError;
    this.currentTime = new Date().getTime().toString();
  }


  ngOnInit(): void {
    this.actions$.pipe(
      ofType(raceAdminActions.updateStatusRaceSucces),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.matDialogRef.close(true);
    });

    this.startTypeLabel = getRaceStartTypeEnum;
    this.startType = Object.values(RaceStartTypeEnum);
    this.resutsStatus = Object.values(ResultsStatusEnum);

    this.raceName = this.data.race.name;

    this.raceTimingForm = this.fb.group({
      startTime: new FormControl(this.data.race?.startTime, [Validators.required]),
      startType: new FormControl(this.data.race?.startType, [Validators.required])
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setCurrentDateTime() {
    this.raceTimingForm.controls['startDateTime'].setValue(toDatetimeLocal(new Date()));
  }

  start() {
    this.store.dispatch(raceAdminActions.updateStatusRace({ id: this.data.race.id, payload: { ...this.raceTimingForm.value, status: RaceStatusEnum.IN_PROGRESS }, eventId: this.data.eventId }));
  }

  get raceAlreadyStarted() {
    return this.data.race.status !== RaceStatusEnum.NOT_STARTED;
  }

}
